import { getFare } from "../actions/fareactions";

export function FareCalculator(distance, time, rateDetails, bookType, settings, fareDetails) {

    var total = 0;
    var grand = 0;
    var gstcommission = 0;
    var convenienceFee = 0;
    let returndistance = settings.convert_to_mile ? (distance / 1.609344) : distance;
    let distanceCityLimit = returndistance - settings.cityLimit;

    if (bookType === 'local') {
        if (distance <= 1) {
            //minimum fareDetails
            total = getBaseFare(fareDetails, 0, 0, 'min', bookType, rateDetails.name.toLowerCase());

            total = total + (time * 1);
            // commission fees for ride earning
            if (rateDetails.convenience_fee_type && rateDetails.convenience_fee_type === 'flat') {
                convenienceFee = rateDetails.convenience_fees;
            } else {
                convenienceFee = (total * parseFloat(rateDetails.convenience_fees) / 100);
            }
            // gst commission for 
            gstcommission = (total * settings.rideGST / 100) + (convenienceFee * settings.commissionGST / 100);

            // grand total
            grand = total + convenienceFee + gstcommission;

        } else if (distance > 1 && distance <= 8) {
            // base fee
            let baseCost = getBaseFare(fareDetails, 0, 0, 'base', bookType, rateDetails.name.toLowerCase());
            // km based fee calculation
            let distanceCost = getFare1(fareDetails, 0, 8, 'km', bookType, rateDetails.name.toLowerCase(), distance);

            total = baseCost + distanceCost + (time * 1);

            // commission fees for ride earning
            if (rateDetails.convenience_fee_type && rateDetails.convenience_fee_type === 'flat') {
                convenienceFee = rateDetails.convenience_fees;
            } else {
                convenienceFee = (total * parseFloat(rateDetails.convenience_fees) / 100);
            }

            // gst commission for 
            gstcommission = (total * settings.rideGST / 100) + (convenienceFee * settings.commissionGST / 100);

            // grand total
            grand = total + convenienceFee + gstcommission;

        } else if (distance > 8 && distance <= 15) {

            // base fee
            let baseCost = getBaseFare(fareDetails, 0, 0, 'base', bookType, rateDetails.name.toLowerCase());
            // km based fee calculation
            let distanceCost1 = getFare1(fareDetails, 0, 8, 'km', bookType, rateDetails.name.toLowerCase(), distance);
            //less distance by sub old values
            let distanceCost2 = getFare1(fareDetails, 8, 15, 'km', bookType, rateDetails.name.toLowerCase(), distance);

            total = baseCost + distanceCost1 + distanceCost2 + (time * 1);
            // commission fees for ride earning
            if (rateDetails.convenience_fee_type && rateDetails.convenience_fee_type === 'flat') {
                convenienceFee = rateDetails.convenience_fees;
            } else {
                convenienceFee = (total * parseFloat(rateDetails.convenience_fees) / 100);
            }
            // gst commission
            gstcommission = (total * settings.rideGST / 100) + (convenienceFee * settings.commissionGST / 100);

            // grand total
            grand = total + convenienceFee + gstcommission;

        } else {
            // base fee
            let baseCost = getBaseFare(fareDetails, 0, 0, 'base', bookType, rateDetails.name.toLowerCase());
            // km based fee calculation
            let distanceCost1 = getFare1(fareDetails, 0, 8, 'km', bookType, rateDetails.name.toLowerCase(), distance);

            let distanceCost2 = getFare1(fareDetails, 8, 15, 'km', bookType, rateDetails.name.toLowerCase(), distance);

            let distanceCost3 = getFare2(fareDetails, 15, 15, distance, 'km', bookType, rateDetails.name.toLowerCase());

            total = baseCost + distanceCost1 + distanceCost2 + distanceCost3 + time * 1;

            // commission fees for ride earning
            if (rateDetails.convenience_fee_type && rateDetails.convenience_fee_type === 'flat') {
                convenienceFee = rateDetails.convenience_fees;
            } else {
                convenienceFee = (total * parseFloat(rateDetails.convenience_fees) / 100);
            }
            // gst commission
            gstcommission = (total * settings.rideGST / 100) + (convenienceFee * settings.commissionGST / 100);
            // grand total
            grand = total + convenienceFee + gstcommission;

        }
    } else if (bookType === 'outstation') {

        distance = distance + distanceCityLimit;

        var basefare = getBaseOutstationFare(fareDetails, 'base', bookType, rateDetails.name.toLowerCase());

        var outstationObject = getOutStationFare(fareDetails, 'km', bookType, rateDetails.name.toLowerCase());

        var allowanceObject = getAllowanceFare(fareDetails, 1, 'allowance', bookType, rateDetails.name.toLowerCase());

        total = (outstationObject.fare * distance) + allowanceObject.fare + basefare + (time * 1) + settings.bookingServiceFee;

        // commission fees for ride earning
        if (rateDetails.convenience_fee_type && rateDetails.convenience_fee_type == 'flat') {
            convenienceFee = rateDetails.convenience_fees;
        } else {
            convenienceFee = (total * parseFloat(rateDetails.convenience_fees) / 100);
        }
        // gst commission for 
        gstcommission = (total * settings.rideGST / 100) + (convenienceFee * settings.commissionGST / 100);

        // grand total
        grand = total + convenienceFee + gstcommission;

    } else if (bookType === 'rental') {

        const rideFareArray = fareDetails.filter(fareitem => fareitem.tripHours === time && fareitem.carType === rateDetails.name.toLowerCase());

        if (rateDetails.convenience_fee_type && rateDetails.convenience_fee_type == 'flat') {
            convenienceFee = rateDetails.convenience_fees;
        } else {
            convenienceFee = (rideFareArray[0].fare * parseFloat(rateDetails.convenience_fees) / 100);
        }

        total = rideFareArray[0].fare;

        gstcommission = (rideFareArray[0].fare * settings.rideGST / 100) + (convenienceFee * settings.commissionGST / 100);

        grand = rideFareArray[0].fare + convenienceFee + gstcommission;

    }

    return {
        totalCost: parseFloat(total).toFixed(2),
        grandTotal: parseFloat(grand).toFixed(2),
        convenience_fees: parseFloat(convenienceFee).toFixed(2),
        commission_fees: parseFloat(gstcommission).toFixed(2)
    }
}

const getBaseFare = (fare, startRange, endRange, fareType, tripType, carname) => {
    var result = fare.filter(item => item.tripStartKM === startRange && item.tripEndKM === endRange && item.tripType === tripType && item.fareType === fareType && item.carType === carname);
    return result.length > 0 ? result[0].fare : 0;
}

const getBaseOutstationFare = (fare, fareType, tripType, carname) => {
    var result = fare.filter(item => item.tripType === tripType && item.fareType === fareType && item.carType === carname);
    return result.length > 0 ? result[0].fare : 0;
}

const getOutStationFare = (fare, fareType, tripType, carname) => {
    var result = fare.filter(item => item.tripType === tripType && item.fareType === fareType && item.carType === carname);
    return result.length > 0 ? result[0] : [];
}

const getAllowanceFare = (fare, tripDay, fareType, tripType, carname) => {
    var result = fare.filter(item => item.dayTrip === tripDay && item.tripType === tripType && item.fareType === fareType && item.carType === carname);
    return result.length > 0 ? result[0] : [];
}

const getFare1 = (fare, startRange, endRange, fareType, tripType, carname, distance) => {
    var result = fare.filter(item => item.tripStartKM === startRange && item.tripEndKM === endRange && item.tripType === tripType && item.fareType === fareType && item.carType === carname);
    let value = 0;
    if (result.length > 0) {
        value = result[0].fare * (endRange > distance ? distance - startRange : endRange - startRange);
    }
    return value;
}

const getFare2 = (fare, startRange, filterEndRange, endRange, fareType, tripType, carname) => {
    var result = fare.filter(item => item.tripStartKM === startRange && item.tripEndKM === filterEndRange && item.tripType === tripType && item.fareType === fareType && item.carType === carname);
    let value = 0;
    if (result.length > 0) {
        value = result[0].fare * (endRange - startRange);
    }
    return value;
}
